"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[878],{

/***/ 7878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_FormContact; }
});

// EXTERNAL MODULE: ./components/Common/index.ts + 2 modules
var Common = __webpack_require__(4565);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./components/PDPAConsent/index.ts + 2 modules
var PDPAConsent = __webpack_require__(9121);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./models/conent.ts
var conent = __webpack_require__(3290);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./utils/gtm.ts
var gtm = __webpack_require__(5834);
// EXTERNAL MODULE: ./utils/translate.ts
var translate = __webpack_require__(954);
// EXTERNAL MODULE: ./utils/validation.ts
var validation = __webpack_require__(1672);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./components/eSignature/FormsSection/SuccessRegistration/SuccessRegistration.tsx
var SuccessRegistration = __webpack_require__(8947);
// EXTERNAL MODULE: ./components/HoneyPot/index.ts + 1 modules
var HoneyPot = __webpack_require__(6067);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
// EXTERNAL MODULE: ./components/shared/ErrorModal.tsx
var ErrorModal = __webpack_require__(4425);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-cloudflare-turnstile/dist/index.js
var dist = __webpack_require__(9807);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/shared/ContactFormNewDesign.tsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var fieldMap = {
  name: 'name',
  email: 'email',
  phone: 'phone',
  company_name: 'company_name',
  job: 'job',
  detail: 'detail'
}; // The registered name, not the CMS name. They coincide for every field the
// forms ship with today, but an editor can add one that `fieldMap` does not
// know — registering those under a shared 'none' key made two such fields
// collide and hid their errors, so a required one killed submit silently.

var fieldNameOf = function fieldNameOf(name) {
  return fieldMap[name] || name || 'none';
};

var DEFAULT_MESSAGE_TH = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "text-lg font-semibold text-center text-red-600 mb-2",
    children: "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14"
  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "text-center text-gray-700 mb-4",
    children: ["\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "mailto:sales@codium.co",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "font-bold text-blue-600",
        children: "sales@codium.co"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22\u0E43\u0E19\u0E04\u0E27\u0E32\u0E21\u0E44\u0E21\u0E48\u0E2A\u0E30\u0E14\u0E27\u0E01"]
  })]
});

var DEFAULT_MESSAGE_EN = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "text-lg font-semibold text-center text-red-600 mb-2",
    children: "Oops! Something went wrong."
  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "text-center text-gray-700 mb-4",
    children: ["You can contact our sales team directly at", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "mailto:sales@codium.co",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "font-bold text-blue-600",
        children: "sales@codium.co"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We apologize for the inconvenience."]
  })]
});

var ContactFormNewDesign = function ContactFormNewDesign(_ref) {
  var product = _ref.product,
      event = _ref.event,
      scroll = _ref.scroll;

  var _useState = (0,react.useState)(true),
      disable = _useState[0],
      setDisable = _useState[1];

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var contactRef = react.useRef();

  var _React$useState = react.useState({
    name: '',
    email: '',
    phone: '',
    company_name: '',
    job: '',
    detail: '',
    user_code: ''
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      forms = _React$useState2[0],
      setForms = _React$useState2[1];

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var _useState2 = (0,react.useState)(null),
      pdpaInfo = _useState2[0],
      setPdpaInfo = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      pdpaFormValid = _useState3[0],
      setPdpaFormValid = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showSuccess = _useState4[0],
      setShowSuccess = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isSubmitting = _useState5[0],
      setIsSubmitting = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      showErrorModal = _useState6[0],
      setShowErrorModal = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      confirmRecaptcha = _useState7[0],
      setConfirmRecaptcha = _useState7[1];

  var _useState8 = (0,react.useState)(''),
      recaptchaToken = _useState8[0],
      setRecaptchaToken = _useState8[1];

  (0,react.useEffect)(function () {
    if (recaptchaToken) {
      setConfirmRecaptcha(true);
    } else {
      setConfirmRecaptcha(false);
    }
  }, [recaptchaToken]);
  (0,react.useEffect)(function () {
    var initPdpaInfo = (0,PDPAConsent/* initialPDPAInfoPayload */.S)(null, 'Codium form');
    setPdpaInfo(initPdpaInfo);
  }, []);
  (0,react.useEffect)(function () {
    if (disable) {
      setDisable(false);
    } else {
      window.scrollTo({
        behavior: 'smooth',
        top: contactRef.current.offsetTop - 56
      });
      setDisable(false);
    }
  }, [scroll]);

  var handleInputForm = function handleInputForm(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    setForms(function (prevForm) {
      return _objectSpread(_objectSpread({}, prevForm), {}, (0,defineProperty/* default */.Z)({}, name, value));
    });
  };

  var clearInput = function clearInput() {
    document.getElementsByName('name')[0].value = '';
    document.getElementsByName('company_name')[0].value = '';
    document.getElementsByName('job')[0].value = '';
    document.getElementsByName('email')[0].value = '';
    document.getElementsByName('phone')[0].value = '';
    document.getElementsByName('detail')[0].value = '';
    document.getElementsByName('user_code')[0].value = '';
  };

  var handleRecaptchaChange = function handleRecaptchaChange(token) {
    setRecaptchaToken(token);
  };

  var handleSubmitForm = function handleSubmitForm(data, e) {
    e.preventDefault();

    if (data.user_code) {
      return;
    }

    if (!recaptchaToken) {
      alert(lang === 'en' ? 'Please confirm that you are not a robot.' : 'กรุณายืนยันว่าคุณไม่ใช่หุ่นยนต์');
      return;
    }

    setIsSubmitting(true);
    submit(data, recaptchaToken);
  };

  var submit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data, recaptchaToken) {
      var _localStorage$getItem;

      var url_ads, from_url, dataForm, res, initPdpaInfo;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url_ads = window.location.href;
              from_url = (_localStorage$getItem = localStorage.getItem('fromUrl')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : url_ads;
              dataForm = {
                name: data.name,
                email: data.email,
                phone: data.phone,
                company_name: data.company_name,
                job: data.job,
                detail: data.detail,
                product: product,
                from_url: from_url,
                contact_points: ['1']
              };
              _context.prev = 3;
              _context.next = 6;
              return axios_default().post("".concat(conent.be, "/api/codium-forms"), {
                data: _objectSpread(_objectSpread({}, dataForm), {}, {
                  codiumForm: forms,
                  contact_points: '["1"]',
                  recaptcha: recaptchaToken
                }),
                pdpa_info: {
                  customer_code: data.email,
                  purposes: pdpaInfo.purposes
                }
              });

            case 6:
              res = _context.sent;
              // Google tag manager for submit
              (0,gtm/* GTMPageView */.o)(url_ads, event);
              setShowSuccess(true);
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);
              setShowErrorModal(true); // Show error modal on error

              (0,esm_exports/* captureException */.Tb)(_context.t0);

            case 15:
              _context.prev = 15;
              setForms({
                name: '',
                email: '',
                phone: '',
                company_name: '',
                job: '',
                detail: '',
                user_code: ''
              });
              clearInput();
              initPdpaInfo = (0,PDPAConsent/* initialPDPAInfoPayload */.S)(null, 'Codium form');
              setPdpaInfo(initPdpaInfo);
              setRecaptchaToken('');
              setIsSubmitting(false);
              return _context.finish(15);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 11, 15, 23]]);
    }));

    return function submit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ErrorModal/* default */.Z, {
      show: showErrorModal,
      onClose: function onClose() {
        return setShowErrorModal(false);
      },
      children: lang === 'en' ? DEFAULT_MESSAGE_EN : DEFAULT_MESSAGE_TH
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      ref: contactRef,
      id: "forms-contact",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
          id: "forms",
          className: "p-6 rounded-lg bg-[#28272C]",
          onSubmit: handleSubmit(handleSubmitForm),
          children: [submitForms.map(function (item, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              children: [item.inputType === 'text' && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "!mb-[32px]",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                  className: "text-p3Medium",
                  children: [(0,translate/* translate */.Iu)(item, 'label', lang), item.required && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-red",
                    children: "*"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
                  className: "!mt-[8px] rounded-lg bg-[#40404B] border-none p-2 text-p3Regular placeholder:text-[#6A6A73] w-full !h-[40px]",
                  type: "text",
                  name: item.name
                }, register(fieldNameOf(item.name), _objectSpread(_objectSpread({
                  onChange: function onChange(e) {
                    return handleInputForm(e);
                  }
                }, (0,validation/* requiredRule */.n0)(item.required, (0,translate/* translate */.Iu)(item, 'label', lang), lang)), (0,validation/* formatRules */.jU)(item.name, lang)))))]
              }), item.inputType === 'textarea' && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "mb-8",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                  className: "text-p3Medium",
                  children: [(0,translate/* translate */.Iu)(item, 'label', lang), item.required && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-red",
                    children: "*"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", _objectSpread({
                  className: "mt-2 rounded-lg bg-[#40404B] border-none p-2 text-p3Regular placeholder:text-[#6A6A73] w-full h-36",
                  name: item.name
                }, register(fieldNameOf(item.name), _objectSpread({
                  onChange: function onChange(e) {
                    return handleInputForm(e);
                  }
                }, (0,validation/* requiredRule */.n0)(item.required, (0,translate/* translate */.Iu)(item, 'label', lang), lang, {
                  possessive: false
                })))))]
              }), errors[fieldNameOf(item.name)] && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-red text-p3Regular px-3 -mt-6 mb-5",
                children: errors[fieldNameOf(item.name)].message
              })]
            }, i);
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(HoneyPot/* HoneyPot */.m, {
            register: register,
            onChange: function onChange(e) {
              return handleInputForm(e);
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "my-8 text-p3Regular",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(PDPAConsent/* PDPAConsent */.d, {
              choices: ['PP-1', 'PP-2', 'PP-3'],
              payload: pdpaInfo,
              setPayload: setPdpaInfo,
              valid: pdpaFormValid,
              setValid: setPdpaFormValid,
              mode: 'dark',
              newDesign: true
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "w-full text-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-fit mx-auto",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((dist_default()), {
                turnstileSiteKey: conent/* turnstileSiteKey */.z,
                callback: function callback(token) {
                  return handleRecaptchaChange(token);
                },
                theme: "light"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              id: "submitBtn",
              type: "submit",
              className: "btn text-white bg-lightBlue hover:bg-lightBlue-700 py-2 px-8 rounded-md disabled:opacity-30 mt-4",
              disabled: !pdpaFormValid || !confirmRecaptcha || isSubmitting,
              children: isSubmitting ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: "flex items-center justify-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })]
                }), lang === 'en' ? 'Sending...' : 'กำลังส่ง...']
              }) : lang === 'en' ? 'Send' : 'ตกลง'
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessRegistration/* default */.Z, {
          showModal: showSuccess,
          setShowModal: setShowSuccess
        })]
      })
    })]
  });
};

/* harmony default export */ var shared_ContactFormNewDesign = (ContactFormNewDesign);
var submitForms = [{
  inputType: 'text',
  label: 'Name',
  labelTH: 'ชื่อ - นามสกุล',
  name: 'name',
  placeHolder: 'Name',
  placeHolderTH: 'ชื่อ - นามสกุล',
  required: true
}, {
  inputType: 'text',
  label: 'Email',
  labelTH: 'อีเมล',
  name: 'email',
  placeHolder: 'Email',
  placeHolderTH: 'อีเมล',
  required: true
}, {
  inputType: 'text',
  label: 'Phone Number',
  labelTH: 'เบอร์โทรศัพท์',
  name: 'phone',
  placeHolder: 'Phone Number',
  placeHolderTH: 'เบอร์โทรศัพท์',
  required: true
}, {
  inputType: 'text',
  label: 'Company Name',
  labelTH: 'บริษัท',
  name: 'company_name',
  placeHolder: 'Company Name',
  placeHolderTH: 'ชื่อบริษัท',
  required: true
}, {
  inputType: 'text',
  label: 'Job Title',
  labelTH: 'ตำแหน่งงาน',
  name: 'job',
  placeHolder: 'Job Title',
  placeHolderTH: 'ตำแหน่งงาน',
  required: true
}, {
  inputType: 'text',
  label: 'What are you interested in?',
  labelTH: 'คุณสนใจในเรื่องอะไร?',
  name: 'detail',
  placeHolder: 'What are you interested in?',
  placeHolderTH: 'คุณสนใจในเรื่องอะไร?',
  required: true
}];
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/shared/FormContact.tsx









var FormContact = function FormContact(_ref) {
  var product = _ref.product,
      event = _ref.event,
      scroll = _ref.scroll,
      _ref$customContainer = _ref.customContainer,
      customContainer = _ref$customContainer === void 0 ? '' : _ref$customContainer;

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var router = (0,next_router.useRouter)();
  var contactRef = react.useRef();
  var title = {
    en: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "Let us design your Digital Journey!"
    }),
    th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u0E43\u0E2B\u0E49\u0E40\u0E23\u0E32\u0E0A\u0E48\u0E27\u0E22\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A Solutions", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E17\u0E35\u0E48\u0E15\u0E2D\u0E1A\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E04\u0E38\u0E13"]
    })
  };
  var description = {
    en: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "We're the leading digital native solution provider, standing by your side\u2014helping you harness digital solutions the right way."
    }),
    th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u0E40\u0E23\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E42\u0E0B\u0E25\u0E39\u0E0A\u0E31\u0E19\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25\u0E40\u0E19\u0E17\u0E35\u0E1F\u0E0A\u0E31\u0E49\u0E19\u0E19\u0E33", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "md:hidden"
      }), "\u0E17\u0E35\u0E48\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E04\u0E35\u0E22\u0E07\u0E02\u0E49\u0E32\u0E07\u0E04\u0E38\u0E13\u2014", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden xxl:block"
      }), "\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E42\u0E0B\u0E25\u0E39\u0E0A\u0E31\u0E19\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E41\u0E25\u0E30\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E20\u0E32\u0E1E"]
    })
  };
  (0,react.useEffect)(function () {
    if (scroll) {
      window.scrollTo({
        behavior: 'smooth',
        top: contactRef.current.offsetTop - 48
      });
    }
  }, [scroll]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    ref: contactRef,
    "aria-labelledby": "homepage-form-contact",
    className: "relative w-full py-12 bg-black",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex-column lg:flex-row gap-9 ".concat(customContainer ? customContainer : 'Container'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex-1",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col gap-5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Title */.D, {
            className: "md:text-left px-2",
            children: title[lang]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "!text-p2Regular !lg:text-p1Regular xxl:!text-[16px] xxl:!leading-[24px] text-center md:text-left px-2",
            children: description[lang]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "fit-content mx-auto md:mx-0 px-2",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
              id: "contact-us-esignature",
              icon: "/icons/speech.svg",
              text: lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา',
              className: "text-sm border border-white",
              onClick: function onClick() {
                return router.push('/contact-us');
              }
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex-1 lg:pl-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_ContactFormNewDesign, {
          product: product,
          event: event
        })
      })]
    })
  });
};

/* harmony default export */ var shared_FormContact = (FormContact);

/***/ })

}]);